import type { AiTextKind, GenerateTextResponse } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const textApi = {
  async generate(
    businessId: string,
    kind: AiTextKind,
    prompt: string,
  ): Promise<GenerateTextResponse> {
    const res = await api.api.businesses[':businessId']['ai-studio'].text.$post({
      param: { businessId },
      json: { kind, prompt },
    })
    return unwrap<GenerateTextResponse>(res)
  },
}
